import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import Product from "./Product";
import { useParams, useSearchParams } from "react-router-dom";
import MSMPagination from './MSMPagination';
import Form from "react-bootstrap/Form";
import CatalogService from '../services/catalog.service';
import SideFilter from './SideFilter';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const ProductList = () => {
  const { categoryId } = useParams();
  const [ searchParams, setSearchParams ] = useSearchParams();
  const [resetPagination, setResetPagination] = useState(0);
  const [range, setRange] = useState([1,12]);
  const [priceFilter, setPriceFilter] = useState(null);
  const dispatch = useDispatch();
  const [catalog, setCatalog] = useState([]);
  const [catalogTotal, setCatalogTotal] = useState(0);
  const [brandFilterItems, setBrandFilterItems] = useState([]);
  const [colorFilterItems, setColorFilterItems] = useState([]);
  const [brandFilter, setBrandFilter] = useState([]);
  const [colorFilter, setColorFilter] = useState([]);
  const [priceRange, setPriceRange] = useState([]);
  const [productPriceRange, setProductPriceRange] = useState([]);
  const [loading, setLoading] = useState(true);
  const featured = useSelector(state => state.featured);
  
  const catalogStatus = useSelector(state => state.catalog.status)
  
  let perPage = 12;

  useEffect(() => {
    console.log("USE EFFECT 1", searchParams.get('searchTerm'));
    async function fetchMyAPI() {
      setLoading(true);
      setCatalog([]);
      var catalog = [];
      catalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), priceFilter]); 
      console.log("NEW CATALOG", catalog);
      setCatalog(catalog.data);
      setCatalogTotal(catalog.count);
      setBrandFilterItems(catalog.brandFilter);
      setColorFilterItems(catalog.colors);
      setProductPriceRange(catalog.priceRange);
      setLoading(false);
      console.log("GET CATALOG" , catalog);    
    }

    fetchMyAPI();
}, []);

  useEffect(() => {
    console.log("USE EFFECT 2", searchParams.get('searchTerm'));
    async function fetchMyAPI() {
      setLoading(true);
      setCatalog([]);
      var catalog = [];
      catalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), priceFilter]); 
      setCatalog(catalog.data);
      setCatalogTotal(catalog.count);
      setBrandFilterItems(catalog.brandFilter);
      setColorFilterItems(catalog.colors);
      setProductPriceRange(catalog.priceRange);
      setRange([1,12]);
      setResetPagination(resetPagination+1);
      setLoading(false);
      console.log("GET CATALOG" , catalog);    
    }

    fetchMyAPI();
  }, [categoryId, searchParams, dispatch]);

  let content = "";

  const reloadData = async(range) => {
    setLoading(true);
    setCatalog([]);
    var newCatalog = await CatalogService.getCatalog([categoryId, range[0], range[1], searchParams.get('searchTerm'), priceFilter, brandFilter, priceRange, colorFilter]);
    console.log("NEW CATALOG", newCatalog);
    setCatalog(newCatalog.data);
    setRange(range);
    setLoading(false);
    
  }

  const updateBrandFilter = async (newBrandFilter) => {
    setBrandFilter(newBrandFilter);
    var newCatalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), priceFilter, newBrandFilter, priceRange, colorFilter]);
    console.log("NEW CATALOG", newCatalog);
    setCatalog(newCatalog.data);
    setRange([1,perPage]);
    setResetPagination(resetPagination+1);
    setCatalogTotal(newCatalog.count);
  }

  const updateColorFilter = async (newColorFilter) => {
    setColorFilter(newColorFilter);
    var newCatalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), priceFilter, brandFilter, priceRange, newColorFilter]);
    console.log("NEW CATALOG COLOR", newCatalog);
    setCatalog(newCatalog.data);
    setRange([1,perPage]);
    setResetPagination(resetPagination+1);
    setCatalogTotal(newCatalog.count);
  }

  const updatePriceRange = async (newPriceRange) => {
    console.log("NEW PRICE RANGE", newPriceRange);
    setPriceRange(newPriceRange);
    var newCatalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), priceFilter, brandFilter, newPriceRange, colorFilter]);
    console.log("NEW CATALOG", newCatalog);
    setCatalog(newCatalog.data);
    setRange([1,perPage]);
    setResetPagination(resetPagination+1);
    setCatalogTotal(newCatalog.count);
    
  }

  const filterChanged = async (e) => {
    console.log("Selected Filter", e.target.value);
    setPriceFilter(e.target.value);
    var newCatalog = await CatalogService.getCatalog([categoryId, 1, perPage, searchParams.get('searchTerm'), e.target.value, brandFilter, priceRange]);
    console.log("NEW CATALOG", newCatalog);
    setCatalog(newCatalog.data);
    setRange([1,perPage]);
    setResetPagination(resetPagination+1);
    setCatalogTotal(newCatalog.count);
  }

  return (
    <div className="container">
        <MSMPagination reload={reloadData} perPage={perPage} total={catalogTotal} reset={resetPagination} />
        <Container style={{marginBottom: 80}}>
      <Row>
        <Col><SideFilter colors={colorFilterItems} brands={brandFilterItems} prices={productPriceRange} updateBrandFilter={updateBrandFilter} updatePriceRange={updatePriceRange} updateColorFilter={updateColorFilter}/></Col>
        <Col xs={10}>
        <div>
        Sort By
          <Form.Group className="mb-3" controlId="state">
                <Form.Select
                  name="filter"
                  onChange={filterChanged}
                  >
                    <option value="relevance">Relevance</option>                          
                    <option value="low">Price: Low to High</option>                          
                    <option value="high">Price: High to Low</option>                          
                   </Form.Select>
              </Form.Group>
        </div>
        <div class="product-container">
          <Container>
            <Row>
              {loading && <Spinner animation="border" />}
              {!loading && searchParams.get('searchTerm') && catalog && catalog.length == 0 && (
                <div className="no-results">No Results Found</div>
              )}
        {catalog && catalog.length > 0 && catalog.map(catalogItem => (
          <Product key={`product_${catalogItem.id}`} product={catalogItem} />
        ))}
            </Row>
          </Container>

        </div>

        </Col>
      </Row>
    </Container>
    </div>
  );
};
export default ProductList;